export function getUrl(path: string, width: number, height: number) {
  //@ts-ignore
  const host = window.C.CLOUDINARY.host;
  //@ts-ignore
  const bucket = window.C.CLOUDINARY.bucket;

  return `//${host}/${bucket}/image/upload/f_jpg,c_pad,w_${width},h_${height}/${path}`;
}

export default { getUrl };
